type EventName =
  // Customise clicked
  | "customise-clicked"
  | `customise-clicked:${string}:v1`
  | `customise-clicked:${string}:v2`

  // Enter Studio (Studio) CTA
  | "enter-studio"
  | `enter-studio:${string}:v1`
  | `enter-studio:${string}:v2`

  // Product Page Visited
  | "product-page"
  | `product-page:${string}:v1`
  | `product-page:${string}:v2`

  // Offline flow
  | "design-offline"
  | `design-offline:${string}:v1`
  | `design-offline:${string}:v2`

  // Sign up CTA at order summary
  | "create-account-summary"
  | `create-account-summary:${string}:v1`
  | `create-account-summary:${string}:v2`

  // Save and exit CTA (Save and create account) when leaving configurator
  | "create-account-exit"
  | `create-account-exit:${string}:v1`
  | `create-account-exit:${string}:v2`

  // Sign up CTA (Log in or sign up) in artwork step
  | "create-account-artwork"
  | `create-account-artwork:${string}:v1`
  | `create-account-artwork:${string}:v2`

  // Submit quote CTA (Submit Quote) through Studio
  | "submit-studio-quote"
  | `submit-studio-quote:${string}:v1`
  | `submit-studio-quote:${string}:v2`

  // Quote submission dialog ("Thanks for submitting your quote!")
  | "end-screen-view-quote"
  | "end-screen-continue-shopping"
  | `end-screen-additional-packaging:${string}`

  // Add to basket - offline artwork flow
  | "add-to-basket"
  | `add-to-basket:${string}:v1`
  | `add-to-basket:${string}:v2`

  // Exit without saving draft
  | "exit-configurator-without-account"
  | `exit-configurator-without-account:${string}:v1`
  | `exit-configurator-without-account:${string}:v2`

  // Checkout CTA (Submit order and pay by bank transfer)
  | "checkout"
  | "pay-by-card"
  | "pay-by-bank-transfer"

  // Design offline upload/delete
  | "design-offline-upload"
  | `design-offline-upload:${string}:v1`
  | `design-offline-upload:${string}:v2`
  | "design-offline-delete"
  | `design-offline-delete:${string}:v1`
  | `design-offline-delete:${string}:v2`
  | `design-offline-download-dieline`

  // Live chat
  | "live-chat-modal-open"
  | "live-chat-modal-close";

function dataLayerSetup() {
  window.dataLayer = window.dataLayer || [];
}

function pushEvent(eventName: EventName, data?: Object) {
  dataLayerSetup();

  if (data) {
    window?.dataLayer?.push({ event: eventName, ...data });
  } else {
    window?.dataLayer?.push({ event: eventName });
  }
}

export const DataLayer = { pushEvent };
